import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";
import "./AdminDuplicateMatches.css";

export default function AdminDuplicateMatches() {
  const [duplicates, setDuplicates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDuplicates();
  }, []);

  const fetchDuplicates = async () => {
    setLoading(true);
    const snap = await getDocs(collection(db, "matches"));

    const list = snap.docs.map(d => ({
      id: d.id,
      ...d.data(),
    }));

    // 🔹 group matches
    const map = {};
    list.forEach(m => {
      const key = `${m.teamA}|${m.teamB}|${m.matchDate}|${m.matchTime}`;
      if (!map[key]) map[key] = [];
      map[key].push(m);
    });

    // 🔹 only duplicates
    const dupList = Object.values(map).filter(g => g.length > 1);
    setDuplicates(dupList);
    setLoading(false);
  };

  const handleDelete = async (id) => {
    const confirm = window.confirm("Una uhakika unataka kufuta match hii?");
    if (!confirm) return;

    await deleteDoc(doc(db, "matches", id));
    alert("Match imefutwa");
    fetchDuplicates();
  };

  if (loading) return <p>Loading duplicates...</p>;

  return (
    <div className="dup-container">
      <h2>⚠️ Duplicate Matches Checker</h2>

      {duplicates.length === 0 && (
        <p>✔ Hakuna matches zinazofanana</p>
      )}

      {duplicates.map((group, idx) => (
        <div key={idx} className="dup-group">
          <h4>
            {group[0].teamA} vs {group[0].teamB} <br />
            {group[0].matchDate} | {group[0].matchTime}
          </h4>

          {group.map((m, i) => (
            <div key={m.id} className="dup-card">
              <span>ID: {m.id}</span>
              <span>Status: {m.status}</span>

              <button
                className="delete-btn"
                onClick={() => handleDelete(m.id)}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}